export const Categories = {
    INTERESSEN: "Interessen",
    FAEHIGKEITEN: "Fähigkeiten",
    ARBEITSVERHALTEN: "Arbeitsverhalten",
    ZIELGRUPPE: "Zielgruppe",
    GEGENSTAENDE: "Gegenstände",
    SCHULFAECHER: "Schulfächer",
    SCHULNOTEN: "Schulnoten",
    ORTE:"Orte",
    FEEDBACK: "Feedback"
};

